"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moize_1 = require("moize");
/**Toma los props de un form y devuelve una función que convierte cualquier componente editor de un valor a uno que ya este ligado a un campo de ese form. Ejemplo
 * const getField =  formFieds(miValor, miOnChange, miErrors);
 * const FormText = getField(kea.Text);
 *
 * Cada field hereda la propiedad readonly del props
 *
 * //FormText esta ligado su value, onChange y errors al de la forma
 * <FormText field="mi_campo" />
 */
function formfields(getProps, errors) {
    const onChange = handleFormChange(getProps);
    const func = function (Component) {
        class FieldComp extends React.Component {
            render() {
                const errs = errors ? errors() : {};
                const { value, readonly } = getProps();
                const fieldProps = this.props;
                const mixedProps = Object.assign({ label: fieldProps.field, value: value && value[fieldProps.field], onChange: onChange(fieldProps.field), error: errs[fieldProps.field], readonly: readonly }, fieldProps);
                const { field } = mixedProps, renderProps = __rest(mixedProps, ["field"]);
                return React.createElement(Component, Object.assign({}, renderProps));
            }
        }
        const ret = FieldComp;
        const innerName = Component.displayName || Component.name || "Component";
        ret.displayName = `FormField(${innerName})`;
        return ret;
    };
    const ret = moize_1.default(func);
    return ret;
}
exports.formfields = formfields;
function createChangeFunction(propsThunk, key) {
    const changeFunc = ((value) => ({ [key]: value }));
    return async function (value) {
        const props = propsThunk();
        if (props.onChange) {
            const change = changeFunc(value);
            const newModel = Object.assign({}, props.value || {}, change);
            await props.onChange(newModel);
        }
    };
}
/**
 * Devuelve una curry-function que toma el props, el nombre de una propiedad de value, y el nuevo valor a asignar en esa propiedad.
 * La segunda funcion siempre devuelve la misma instancia para el mismo nombre de propiedad

 * En su clase cree la funcion de cambio:
 * const handleChange = handleFormChange(() => this.props);
 *
 * En los componentes editores:
 * <Text value={this.props.text} onChange={handleChange("Nombre")} />
 *
 * @param propsThunk Funcion que devuelve un objeto con el valor actual y la función de cambio
 * @param key Nombre de la propiedad
 * @param value Nuevo valor de la propiedad.
 *
 */
function handleFormChange(propsThunk) {
    const cache = {};
    return function (key) {
        const cacheValue = cache[key];
        const ret = cacheValue || (cache[key] = createChangeFunction(propsThunk, key));
        return ret;
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/formfield.js
// module id = 502
// module chunks = 0